module.exports = __webpack_public_path__ + "static/img/MARNUS_LABUSCHAGNE.eab5462.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/MARNUS_LABUSCHAGNE.jpg
// module id = 4yHN
// module chunks = 0